import { parseMessageText } from '@/lib/utils/render-text'
import { MatrixHtml } from '@/lib/utils/html-render'
import { CollapsibleCode } from './CollapsibleCode'

interface FormattedTextProps {
  text: string
  /** Raw `formatted_body` when `format` is `org.matrix.custom.html`. */
  html?: string
  /** Active room, used to resolve mention pills to display names. */
  roomId?: string
}

export function FormattedText({ text, html, roomId }: FormattedTextProps) {
  if (html && html.trim()) {
    return <MatrixHtml html={html} roomId={roomId} />
  }

  const segments = parseMessageText(text)

  return (
    <span>
      {segments.map((seg, i) => {
        switch (seg.type) {
          case 'bold':
            return <strong key={i} className="font-semibold">{seg.content}</strong>
          case 'italic':
            return <em key={i}>{seg.content}</em>
          case 'code':
            return (
              <code key={i} className="px-1 py-0.5 rounded text-xs font-data bg-[rgb(var(--np-raised))] text-[rgb(var(--np-accent))]">
                {seg.content}
              </code>
            )
          case 'codeblock':
            return <CollapsibleCode key={i} text={seg.content} />
          case 'link':
            return (
              <a
                key={i}
                href={seg.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[rgb(var(--np-accent))] hover:underline break-all"
              >
                {seg.content}
              </a>
            )
          default:
            return <span key={i}>{seg.content}</span>
        }
      })}
    </span>
  )
}
